import { useContext, type ReactNode } from 'react'
import { HIDDEN_ATTRS, HIDE_ATTR, PRIVATE_ATTRS, PrivateAreaContext } from './privateArea'

/** Marks what it wraps as private for the overlays opened from there (usePrivateAttrs): put it inside an element
 *  that carries PRIVATE_AREA (lib/analytics), or HIDDEN_AREA with `hide` (chats and direct messages). A scope inside a
 *  hidden one stays hidden. It renders no element of its own. */
export function PrivateScope({ children, hide }: { children: ReactNode; hide?: boolean }) {
  const parent = useContext(PrivateAreaContext)
  const value = hide || HIDE_ATTR in parent ? HIDDEN_ATTRS : PRIVATE_ATTRS
  return <PrivateAreaContext.Provider value={value}>{children}</PrivateAreaContext.Provider>
}
